import { SyntheticEvent, ChangeEvent } from 'react';
import { FieldBBType, FIELD_DATA_ATTR, FieldEditMode } from 'client/components/common/BuildingBlocks/Fields/constants';

export type TFieldState = {
	editMode: FieldEditMode;
	value: string;
	readOnly: boolean;
	pending: boolean;
};

export type TFieldProps = {
	className: string;
	type: FieldBBType;
	name: string;
	placeholder?: string;
	autoComplete?: 'off';
	[FIELD_DATA_ATTR]: string;
	value?: TFieldState['value'];
	readOnly?: TFieldState['readOnly'];
	onDoubleClick?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onBlur?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onFocus?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onClick?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export enum DateFormat {
	DDMMYYYY = 'DDMMYYYY',
	MMDDYYYY = 'MMDDYYYY',
	YYYYMMDD = 'YYYYMMDD',
}

export enum DateDelimiter {
	'.' = '.',
	'/' = '/',
	'-' = '-',
}
